import { filter, first, pipe } from 'rxjs';

import { createFeatureSelector, select } from '@ngrx/store';

import { ScopeState, scopeFeature } from './scope.feature';

export const selectScopeState = createFeatureSelector<ScopeState>('scope');

export const selectValidScopeState = pipe(
  select(scopeFeature.selectScopeState),
  filter((scopeState) => !!scopeState && !!scopeState.company && !!scopeState.administratorCompany),
);

export const selectFirstValidScopeState = pipe(selectValidScopeState, first());
